(function () {
  'use strict';

  function initTrupahadiImpact(section) {
    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    const items = section.querySelectorAll('[data-impact-item]');

    if (!items.length) {
      return;
    }

    /* =========================================
       REDUCED MOTION
       ========================================= */

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;


    if (reducedMotion) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });

      return;
    }


    /* =========================================
       SCROLL REVEAL
       ========================================= */

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });

      return;
    }


    const observer = new IntersectionObserver(
      function (entries, observerInstance) {

        entries.forEach(function (entry) {

          if (!entry.isIntersecting) {
            return;
          }

          const item = entry.target;

          const index = Array.prototype.indexOf.call(
            items,
            item
          );

          item.style.transitionDelay =
            Math.max(index, 0) * 120 + 'ms';

          item.classList.add('is-visible');

          observerInstance.unobserve(item);
        });

      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      }
    );


    items.forEach(function (item) {
      observer.observe(item);
    });
  }


  /* =========================================
     INITIAL LOAD
     ========================================= */

  function initAll() {
    document
      .querySelectorAll('.trupahadi-impact')
      .forEach(initTrupahadiImpact);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }


  /* =========================================
     SHOPIFY THEME EDITOR
     ========================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section = event.target.querySelector(
        '.trupahadi-impact'
      );

      if (section) {
        section.dataset.initialized = 'false';
        initTrupahadiImpact(section);
      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      const section = event.target.querySelector(
        '.trupahadi-impact'
      );

      if (section) {
        section.dataset.initialized = 'false';
      }

    }
  );

})();